import INFTCollections from '../../models/INFTCollections'
import LootFishCard from '../../nftFormats/LootFish/Card/LootFishCard'
import LootFishDetail from '../../nftFormats/LootFish/Detail/LootFishDetail'
import LootFishActivityDetail from '../../nftFormats/LootFish/Activity/LootFishActivityDetail'
import LootFishLogo from '../../../../assets/nft-logo/LootFish.jpg'

export const LootFishData: INFTCollections[] = [
  {
    id: 'LootFish',
    tokenAddress: '0x8372530bc1c3eF2739213059b113C76e143bc25d',
    name: 'Loot Fish',
    cardFormat: LootFishCard,
    detailFormat: LootFishDetail,
    activityFormat: LootFishActivityDetail,
    category: 1,
    creatorAddress: '0xa040978BdEC05Bfca9BA534D83eb3047f51425ce',
    logo: LootFishLogo,
    website: 'https://www.lootfish.co/',
    twitter: 'LootFishNFT',
    telegram: 'https://t.me/lootfish',
    discord: 'https://discord.com/invite/K3KGeV7JfF'
  }
]

export const LootFishCategoryData = {
  [LootFishData[0].tokenAddress.toLowerCase()]: LootFishData[0].category
}
